import { useContext } from 'react';
import { LiberisContext } from './liberis-context';
export var useLiberisContext = function () {
    var context = useContext(LiberisContext);
    if (!context) {
        throw new Error('useLiberisContext must be used within a LiberisProvider');
    }
    return context;
};
